import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { NodeRenderer } from '@contentful/rich-text-react-renderer';
import MlVideoPlayer from 'components/commercetools-ui/molecules/video-player';

interface EmbeddedEntryNode {
  data: {
    target: {
      sys: {
        contentType: {
          sys: {
            id: string;
          };
        };
      };
      fields: {
        videoId?: string;
        [key: string]: any;
      };
    };
  };
}

// Type guard to check if a node is an embedded video player
const isVideoPlayerNode = (node: any): node is EmbeddedEntryNode => {
  return (
    node?.data?.target?.sys?.contentType?.sys?.id === 'videoPlayer' &&
    typeof node?.data?.target?.fields?.videoId === 'string'
  );
};

export const videoPlayerRenderer: Record<string, NodeRenderer> = {
  [BLOCKS.EMBEDDED_ENTRY]: (node) => {
    if (isVideoPlayerNode(node)) {
      const videoId = node.data.target.fields.videoId;
      const title = node.data.target.fields.title;

      if (!videoId) return null;

      return <MlVideoPlayer videoId={videoId} title={title} className="pt-8" />;
    }

    return null;
  },
};
